module.exports = __webpack_public_path__ + "img/photoshop.fce42083.svg";